module.exports = __webpack_public_path__ + "static/img/crmdown2.7cab53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/crmdown2.png
// module id = OJ8F
// module chunks = 80